import React from 'react';
import { IntegrationsMarquee } from './IntegrationsMarquee';

export function HonestProof() {
  return (
    <section data-testid="landing-honest-proof-section" className="py-24 md:py-28 px-6 border-y border-white/10">
      <div className="max-w-2xl mx-auto text-center mb-6">
        <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white mb-5">
          Tecnología real, construida para e-commerce
        </h2>
        <p className="text-zinc-400 leading-relaxed">
          No usamos métricas inventadas ni testimonios falsos. Nuestro compromiso es simple:
          una integración perfecta, rendimiento ultrarrápido y tecnología que resuelve
          problemas reales del día a día de un e-commerce.
        </p>
      </div>
      <IntegrationsMarquee />
    </section>
  );
}
